import React from 'react';
import './BrandMark.css';

function BrandMark({
  size = 'md',
  className = '',
  cheers = false,
  onClick = null,
  title = null
}) {
  const classes = [
    'brand-mark',
    `brand-mark--${size}`,
    cheers ? 'brand-mark--cheers' : '',
    onClick ? 'brand-mark--clickable' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  const inner = (
    <svg
      className="brand-mark__img"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="14" fill="#173662" />
      <path
        d="M18 24h22a2 2 0 0 1 2 2v22a6 6 0 0 1-6 6H22a6 6 0 0 1-6-6V26a2 2 0 0 1 2-2z"
        fill="#F7F4EE"
      />
      <path
        d="M18 32h22v16a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4V32z"
        fill="#D7A35A"
      />
      <path
        d="M16.5 24c0-4.2 3.4-7.5 8.2-7.5 1.7 0 3.2.4 4.5 1.2A7.2 7.2 0 0 1 35 16.5c4.5 0 8.2 3 8.2 6.8v.7H16.5V24z"
        fill="#FFFFFF"
      />
      <circle cx="24" cy="21" r="2.1" fill="#FFFFFF" />
      <circle cx="30.5" cy="19.5" r="2.3" fill="#FFFFFF" />
      <circle cx="37" cy="21.2" r="2" fill="#FFFFFF" />
      <path
        d="M42 30h2.5a5.5 5.5 0 0 1 0 11H42"
        fill="none"
        stroke="#F7F4EE"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <rect
        x="21"
        y="35"
        width="3.5"
        height="10"
        rx="1.5"
        fill="#F3D7A4"
        opacity=".6"
      />
    </svg>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={classes}
        onClick={onClick}
        title={title || undefined}
        aria-label={title || 'Слово Дня'}
      >
        {inner}
      </button>
    );
  }

  return (
    <span className={classes} aria-hidden="true">
      {inner}
    </span>
  );
}

export default BrandMark;
